import PropTypes from "prop-types";
import { Button } from "reactstrap";
import useUser from "../../../../../core/hooks/use-user";
import useModal from "../../../../../core/hooks/use-modal";
import FormEliminarCuadroTurno from "../form-eliminar-cuadro-turnos-automaticos";

const BotonEliminarCuadroTurnos = ({
    sedeAreaLider,
    onEliminarCuadroTurnos,
}) => {
    const { userCan } = useUser();
    const modalEliminarCuadroTurnos = useModal();

    const mostrarModal = async () => {
        modalEliminarCuadroTurnos.open();
    };

    const cuadroDeTurnosEliminado = () => {
        modalEliminarCuadroTurnos.close();
        onEliminarCuadroTurnos && onEliminarCuadroTurnos();
    };

    if (userCan("eliminarCuadroTurnoGeneral")) {
        return (
            <>
                <Button
                    title="Eliminar Cuadro de Turnos"
                    className="ml-2"
                    color="danger"
                    onClick={mostrarModal}
                >
                    <i className="fas fa-times-circle"></i>
                </Button>
                <FormEliminarCuadroTurno
                    sedeAreaLider={sedeAreaLider}
                    modal={modalEliminarCuadroTurnos}
                    onEliminarCuadroTurnos={cuadroDeTurnosEliminado}
                />
            </>
        );
    }

    return <></>;
};

BotonEliminarCuadroTurnos.propTypes = {
    sedeAreaLider: PropTypes.string,
    onEliminarCuadroTurnos: PropTypes.func,
};

export default BotonEliminarCuadroTurnos;
